"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _pluralizer = _interopRequireDefault(require("../../helpers/pluralizer"));

var _iconRebatesDetails = _interopRequireDefault(require("../../../cart/icons/icon-rebates-details.svg"));

var _iconCaret = _interopRequireDefault(require("../../icons/icon-caret.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DiscountDetails = /*#__PURE__*/function (_Component) {
  _inherits(DiscountDetails, _Component);

  var _super = _createSuper(DiscountDetails);

  function DiscountDetails(props) {
    var _this;

    _classCallCheck(this, DiscountDetails);

    _this = _super.call(this, props);
    _this.state = {
      isDetailsOpened: false
    };
    _this.buttonRef = /*#__PURE__*/_react["default"].createRef();
    _this.handleToggeleDetailsStatus = _this.handleToggeleDetailsStatus.bind(_assertThisInitialized(_this));
    _this.handleOutsideClick = _this.handleOutsideClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DiscountDetails, [{
    key: "handleToggeleDetailsStatus",
    value: function handleToggeleDetailsStatus() {
      var isDetailsOpened = this.state.isDetailsOpened;
      this.setState({
        isDetailsOpened: !isDetailsOpened
      }, this.handleEventListeners);
    }
  }, {
    key: "handleEventListeners",
    value: function handleEventListeners() {
      var isDetailsOpened = this.state.isDetailsOpened;

      if (isDetailsOpened) {
        window.addEventListener('touchstart', this.handleOutsideClick);
      } else {
        window.removeEventListener('touchstart', this.handleOutsideClick);
      }
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(event) {
      if (!this.buttonRef.current.contains(event.target)) {
        this.handleToggeleDetailsStatus(false);
      }
    }
  }, {
    key: "handleToggleKeydown",
    value: function handleToggleKeydown(event) {
      // Space or Enter pressed
      if (event.key === ' ' || event.key === 'Enter') {
        this.handleToggeleDetailsStatus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          discounts = _this$props.discounts,
          formattedTotalValue = _this$props.formattedTotalValue,
          type = _this$props.type,
          className = _this$props.className;
      var isDetailsOpened = this.state.isDetailsOpened;
      var caretClass = (0, _classnames["default"])({
        'rebate-details__rebates-details-dropdown-icon': !isDetailsOpened,
        'rebate-details__rebates-details-dropdown-icon--open': isDetailsOpened
      });
      var discountLanguage = {
        rebate: {
          title: 'Instant rebates',
          type: 'rebate'
        },
        promotion: {
          title: 'Promotions',
          type: 'promotion'
        },
        program: {
          title: 'Enrollment bonus',
          type: 'rebate'
        }
      }[type];

      if (!discounts || !discounts.length > 0) {
        return null;
      }

      var zeroValue = discounts.findIndex(function (discount) {
        return discount && discount.value !== '$0.00';
      }) === -1;
      var wrapperClass = (0, _classnames["default"])('rebate-details__wrapper', {
        'rebate-details__wrapper--warning': zeroValue
      });
      var drawerClass = (0, _classnames["default"])('rebate-details__rebate-drawer', {
        'rebate-details__rebate-drawer--warning': zeroValue
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(className, " ").concat(wrapperClass),
        ref: this.buttonRef
      }, /*#__PURE__*/_react["default"].createElement("div", {
        "aria-expanded": isDetailsOpened,
        className: "rebate-details__summary",
        role: "button",
        onClick: this.handleToggeleDetailsStatus,
        onKeyDown: function onKeyDown(event) {
          return _this2.handleToggleKeydown(event);
        },
        onBlur: function onBlur() {
          return isDetailsOpened && _this2.handleToggeleDetailsStatus();
        },
        tabIndex: 0
      }, !zeroValue && /*#__PURE__*/_react["default"].createElement(_iconRebatesDetails["default"], {
        className: "rebate-details__rebates-details-icon",
        "aria-hidden": "true"
      }), "".concat(formattedTotalValue, " (").concat(discountLanguage.title, ")"), /*#__PURE__*/_react["default"].createElement(_iconCaret["default"], {
        className: caretClass
      })), isDetailsOpened && /*#__PURE__*/_react["default"].createElement("div", {
        className: drawerClass
      }, discounts.map(function (discount, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "rebate-details__rebate-row",
          key: "".concat(discount.title).concat(discount.count * (index + 1))
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "rebate-details__rebate-details"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "rebate-details__title"
        }, discount.title), /*#__PURE__*/_react["default"].createElement("div", {
          className: "rebate-details__applied"
        }, "".concat(discount.count, " ").concat((0, _pluralizer["default"])(discount.count, discountLanguage.type), " applied")), discount.ineligibilityMessage && discount.ineligibilityMessage.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
          className: "rebate-details__ineligibility-message"
        }, discount.ineligibilityMessage)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "rebate-details__rebate-value"
        }, discount.value));
      })));
    }
  }]);

  return DiscountDetails;
}(_react.Component);

DiscountDetails.propTypes = {
  discounts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string.isRequired,
    count: _propTypes["default"].number.isRequired,
    value: _propTypes["default"].string.isRequired,
    ineligibilityMessage: _propTypes["default"].string
  })).isRequired,
  type: _propTypes["default"].oneOf(['promotion', 'rebate', 'program']).isRequired,
  formattedTotalValue: _propTypes["default"].string,
  className: _propTypes["default"].string
};
DiscountDetails.defaultProps = {
  formattedTotalValue: '',
  className: ''
};
var _default = DiscountDetails;
exports["default"] = _default;